var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageUploadIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 52,
  height: 72,
  viewBox: "0 0 52 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.87492 0C2.18258 0 0 2.19787 0 4.90908V67.0908C0 69.802 2.18257 71.9999 4.87492 71.9999H47.1242C49.8166 71.9999 51.9991 69.802 51.9991 67.0908V19.6363L32.4995 0H4.87492Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.87492 71.9997C2.18258 71.9997 0 69.8019 0 67.0906V66.2725C0 68.9837 2.18258 71.1815 4.87492 71.1815H47.1242C49.8166 71.1815 51.9991 68.9837 51.9991 66.2725V67.0906C51.9991 69.8019 49.8166 71.9997 47.1242 71.9997H4.87492Z",
  fill: "#E4E6EA"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M51.9973 36.4088V19.6361L49.1536 16.7725H35.4399C34.3541 16.7725 33.8104 18.0944 34.5782 18.8675L51.9973 36.4088Z",
  fill: "url(#paint0_linear_1005_4724)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M32.5 0L51.9997 19.6363H37.3749C34.6826 19.6363 32.5 17.4385 32.5 14.7272V0Z",
  fill: "#EEEFF1"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 27C10.8954 27 10 27.8954 10 29V57C10 58.1046 10.8954 59 12 59H40C41.1046 59 42 58.1046 42 57V29C42 27.8954 41.1046 27 40 27H12ZM38 32H14V50H38V32Z",
  fill: "#EEEFF1"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M23 36L29.0622 46.5H16.9378L23 36Z",
  fill: "#DADDE3"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M30 39L35.1962 46.5H24.8038L30 39Z",
  fill: "#DADDE3"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1005_4724",
  x1: 51.998,
  y1: 40.4995,
  x2: 46.3307,
  y2: 14.536,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C5C9D1"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageUploadIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image_upload_icon.a90e6797ceab64d822f9958b93f96365.svg";